import { getPropertyIdLabel } from '@kaiizen/kai-pro-api';
import { useAllOrgSettings, useCurrentOrg } from '@kaiizen/kai-pro-api-react-state';

/**
 * Resolve the current org's property ID label with alias override support.
 */
export const usePropertyIdLabel = () => {
  const { currentOrg } = useCurrentOrg();
  const { allOrgSettings } = useAllOrgSettings();

  return getPropertyIdLabel(
    currentOrg?.name,
    allOrgSettings?.brandSettings?.orgAlias,
  );
};
